<template>
  <div>
    <h5>Please enter your order ID</h5>
    <tml-form ref="returnForm" form-name="order-return-tracking-form">
      <tml-input
        placeholder="Order ID (e.g. 123123)"
        type="text"
        field-name="returnOrderId"
        :validation-rules="{required: true, numeric: true}"
        @submit="onSubmitReturn"
      />
      <tml-button
        v-if="!complete"
        text="Find Order"
        fill
        :loading="loading"
        @click="onSubmitReturn"
      />
    </tml-form>
    <div v-if="returnFound">
      <div v-for="returnOrder in returnOrders" :key="returnOrder.id">
        <div v-for="(item, index) in returnOrder.items" :key="index">
          <div v-if="returnOrder.status === 'exchanged'">
            <p>
              We've received the original item. Your
              <span v-if="item.options.Colour">{{ item.options.Colour }}</span>
              <span v-if="item.options.Size">size {{ item.options.Size }}</span>
              <strong>{{ item.productName }}</strong>
              <span v-if="returnOrder.wasEverComplete">was dispatched on
                <strong>
                  {{ returnOrder.statusUpdateDatetime }}
                </strong>
              </span>
              <span v-else>is currently being processed.</span>
            </p>
          </div>
          <div v-else>
            <p>
              We've received a returned
              <span v-if="item.options.Colour">{{ item.options.Colour }}</span>
              <span
                v-if="item.options.Size && item.options.Size !== 'One Size'"
              >
                size {{ item.options.Size }}
              </span>
              <strong>{{ item.productName }}</strong>
              on <strong>{{ returnOrder.statusUpdateDatetime }}</strong>
            </p>
          </div>
        </div>
      </div>
      <p>
        If the item you returned isn't listed above it either hasn't yet arrived
        at the factory or is waiting to be processed.
      </p>
    </div>
  </div>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';

export default {
  name: 'HelpReturnOrderTracking',

  data() {
    return {
      returnOrders: null,
      returnFound: false,
      loading: false,
      complete: false,
    };
  },

  methods: {
    onSubmitReturn() {
      this.$refs.returnForm.validateAll().then(success => {
        if (success) {
          this.loading = true;
          const returnFormData =
            this.$store.getters['forms/order-return-tracking-form/formData'];

          if (returnFormData) {
            this.axios
              .post(formatUrl('/omnis/v3/contact/find-return-order/'), {
                returnOrderId: returnFormData.returnOrderId
                  ? returnFormData.returnOrderId.value
                  : null,
              })
              .success(data => {
                if (data) {
                  if ('message' in data) {
                    snackbar.error(data.message);
                  } else {
                    this.returnOrders = data;
                    this.returnFound = true;
                    this.complete = true;
                  }
                }
              })
              .validation(message => {
                if (message) {
                  snackbar.error(message);
                }
              })
              .oops()
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-top: 1em;
  margin-bottom: 1em;
}

h5 {
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>
